export default __webpack_public_path__ + "static/media/logo-asana.d758f410.svg";